module.exports = __webpack_public_path__ + "img/overall-mental-health.e40060c3.svg";